<div [dir]="direction">
    <router-outlet></router-outlet>
</div>
